import { LayoutGrid, LogOut, Moon, Settings, Sun } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { usePrefs } from '../../application/stores/prefsStore';
import { useAuth } from '../app/useAuth';
import { useT } from '../i18n/i18n';
import { Avatar } from './Avatar';
import { Menu } from './Menu';

export function UserMenu() {
  const t = useT();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const theme = usePrefs((s) => s.theme);
  const setTheme = usePrefs((s) => s.setTheme);
  if (!user) return null;
  const dark = document.documentElement.dataset.theme === 'dark';
  return (
    <Menu
      trigger={(p) => (
        <button
          type="button"
          {...p}
          aria-label={user.name}
          style={{
            border: 0,
            padding: 2,
            background: 'none',
            borderRadius: '50%',
            cursor: 'pointer',
          }}
        >
          <Avatar name={user.name} color={user.color} size={34} />
        </button>
      )}
      items={[
        {
          label: t('nav.boards'),
          icon: <LayoutGrid size={16} />,
          onSelect: () => navigate('/boards'),
        },
        {
          label: t('nav.settings'),
          icon: <Settings size={16} />,
          onSelect: () => navigate('/settings'),
        },
        {
          label: dark ? t('theme.light') : t('theme.dark'),
          icon: dark ? <Sun size={16} /> : <Moon size={16} />,
          onSelect: () =>
            setTheme(theme === 'system' ? (dark ? 'light' : 'dark') : dark ? 'light' : 'dark'),
        },
        'separator',
        {
          label: t('nav.logout'),
          icon: <LogOut size={16} />,
          onSelect: async () => {
            await logout();
            navigate('/');
          },
        },
      ]}
    />
  );
}
